import http from "./../services/httpService";
import {getFiltersString} from "../utils/misc";


const documentFilterMap = {
    // categories: 'categories__name',
    source: 'source',
    created_by_full_name: 'created_by__id'
}

export function getDownloadFiltersName(filters) {
    return filters.map(el => ({id: documentFilterMap[el.id], value: el.value}))
}

export async function getDocuments(uploadsOrAll, page, search = '', filters = []) {
    const resp = await http.get(`/documents/`
        // + (categoryId ? `?category_id=${categoryId}` : '')
        + (uploadsOrAll === "uploads" ? `direct_upload_documents/` : '')
        + (page > 0 ? `?page=${page}` : '')
        + (search ? `&search=${search}` : '')
        + (filters.length ? `&${getFiltersString(getDownloadFiltersName(filters))}` : '')
    )
    return resp.data.results
}

export async function getDocument(id) {
    const resp = await http.get(`/documents/${id}/`)
    return resp.data
}

export async function postDocument(data) {
    const resp = await http.post('/documents/', data)
    return resp.data
}

export async function addFileToDocument(formData, id) {
    const resp = await http.post(`/documents/${id}/add_file/`, formData)
    return resp.data
}

export async function patchDocument(data) {
    const resp = await http.patch(`/documents/${data.id}/`, data)
    return resp.data
}

export async function deleteDocument(id) {
    const resp = await http.delete(`/documents/${id}/`)
    return resp.data
}

export async function deleteDocuments(data) {
    const resp = await http.post(`/documents/delete_multiple/`, data)
    return resp.data
}

export async function getAsanaDocuments() {
    const resp = await http.get(`/documents/?source=ASANA`)
    return resp.data.results
}

export async function refreshAsana() {
    const resp = await http.post(`/documents/refresh_asana/`)
    return resp.data
}

export async function preprocessAndIngestOwnDocuments() {
    const resp = await http.post(`/core/preprocess_and_ingest_own_documents/`)
    return resp.data
}

